import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

/**
 * Pantalla mostrada al entrar al link de una vacante a la que el candidato
 * ya postuló. Evita re-llenar el formulario y la falsa sensación de
 * "postulación enviada" duplicada.
 */
const PortalAlreadyAppliedScreen = ({ position, application, onViewApplications, fairHref = null }) => {
  const { t, i18n } = useTranslation();
  const dateLocale = i18n.language?.startsWith('en') ? 'en-US' : 'es-CL';

  const formatDate = (timestamp) => {
    if (!timestamp) return null;
    // Firestore Timestamp serializado por JSON ({_seconds}), objeto Timestamp o string
    let date;
    if (timestamp._seconds) date = new Date(timestamp._seconds * 1000);
    else if (timestamp.toDate) date = timestamp.toDate();
    else date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString(dateLocale);
  };

  const appliedDate = formatDate(application?.createdAt);
  const positionName = position?.name || application?.positionName || '';

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', px: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 480 }}>

        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box
            component="img"
            src="/amandalogoh.png"
            alt="Amanda HR"
            sx={{ height: 40, mb: 3 }}
          />
        </Box>

        <Paper elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2, p: 4, textAlign: 'center' }}>
          <InfoOutlinedIcon sx={{ fontSize: 64, color: '#6A5AF9', mb: 2 }} />

          <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
            {t('portal.alreadyAppliedTitle')}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {appliedDate
              ? t('portal.alreadyAppliedMessage', { position: positionName, date: appliedDate })
              : t('portal.alreadyAppliedMessageNoDate', { position: positionName })}
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={onViewApplications}
            sx={{ backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' }, py: 1.5 }}
          >
            {t('portal.viewMyApplications')}
          </Button>

          {/* Desde una feria: volver a sus vacantes (PLAN_FERIAS) */}
          {fairHref && (
            <Button
              variant="outlined"
              fullWidth
              href={fairHref}
              sx={{ mt: 1.5, py: 1.5, borderColor: '#6A5AF9', color: '#6A5AF9' }}
            >
              {t('portal.fair.backToFair')}
            </Button>
          )}
        </Paper>

      </Box>
    </Box>
  );
};

export default PortalAlreadyAppliedScreen;
